import Storage from '@comm/utils/storagehandle'
const state = {
  matchInfo: Storage.getItem('matchInfo') || null,
  activeMenu: Storage.getItem('activeMenu') || 0,
  miniCode: Storage.getItem('miniCode') || null,
  scheduleCompetitionDate: Storage.getItem('scheduleCompetitionDate') || null,
  scrollToLeft: Storage.getItem('scrollToLeft') || 0,
}

const getters = {
  matchInfo: state => state.matchInfo,
  activeMenu: state => state.activeMenu,
  miniCode: state => state.miniCode,
  scheduleCompetitionDate: state => state.scheduleCompetitionDate,
  scrollToLeft:state=> state.scrollToLeft,

}

const actions = {

}

const mutations = {
  MATCH_CHANGE_MATCH_INFO (state, data) {
    state.matchInfo = data
    Storage.setItem('matchInfo', state.matchInfo)
  },
  MATCH_CHANGE_MINI_CODE (state, data) {
    state.miniCode = data
    Storage.setItem('miniCode', state.miniCode)
  },
  MATCH_CHANGE_ACTIVE_MENU (state, data) {
    state.activeMenu = data
    Storage.setItem('activeMenu', state.activeMenu)
  },
  MATCH_CHANGE_SCHEDULE_COMPETITION_DATE (state, data) {
    state.scheduleCompetitionDate = data
    Storage.setItem('scheduleCompetitionDate', state.scheduleCompetitionDate)
  },
  MATCH_SCROLLTOLEFT (state, data) {
    state.scrollToLeft = data
    Storage.setItem('scrollToLeft', state.scrollToLeft)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/district/store/modules/match.js